import { Deserializable } from '../../protocols/deserializable';
import { FundTypeId } from '../../enum/shared/fund-type-id';

export class CreateWithdrawalInstructionRequest implements Deserializable {
  public fund: FundTypeId;
  public percentage: number;

  constructor(fund: FundTypeId, percentage: number) {
    this.fund = fund;
    this.percentage = percentage;
  }

  public onDeserialize(): void {}
}
